import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const PaymentsPage = lazy(() => import('./PaymentsPage'));

const PaymentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Payments,
  routes: [
    {
      path: 'payments',
      element: <PaymentsPage />,
    },
  ],
};

export default PaymentsConfig;
